export const mainColors = {
  white: '#FFFFFF',
  lightGrey: '#f5f5f5',
  darkGrey: '#cccccc',
  ratingYellow: '#ffd700',
  loadingBlue: '#cb6767',
  warningBlue: '#597eaa',
  successGreen: '#75b465',
  feedbackRed: '#CC0000'
}
